import React, { Component } from "react";
import Aux from "../../../../hoc/Auxilliary";
import {
  getStates,
  createState,
  updateState,
  deleteState
} from "../../../../data-service-admin";
import { ToastContainer } from "react-toastr";
import DeleteModal from "../Common/DeleteModal";
import AddEditModal from "../Common/AddEditModal";
import Grid from "../Common/Grid";
import {
  showSuccessToastMessage,
  showErrorToastMessage
} from "../../../../utilities";
import Spinner from "../../../User/Common/Spinner/Spinner";
import Search from "../Common/Search";
import { emptyCheck } from "../../../../utilities";
import AdminBreadcrumb from "../Common/Breadcrumb";
import RequiredField from "../Common/RequiredField";

class AdminStates extends Component {
  state = {
    countryName: "",
    masterstates: [],
    states: [],
    selectedState: {},
    showModal: false,
    modalTitle: "",
    showDeleteModal: false,
    modalDeleteTitle: "",
    modalDeleteMessage: "",
    action: "edit",
    showSpinner: false,
    searchTerm: "",
    errorMessage: ""
  };
  componentDidMount() {
    this.getStatesFromService();
  }
  showSpinner(isShow) {
    this.setState({
      showSpinner: isShow
    });
  }
  getStatesFromService() {
    this.showSpinner(true);
    getStates(this.props.match.params.id)
      .then(response => {
        this.showSpinner(false);
        this.setState({ states: response.data, masterstates: response.data });
      })
      .catch(error => {
        this.showSpinner(false);
        // console.log(error);
        this.showErrorMessage(error);
      });
  }

  editState(state) {
    this.setState({
      action: "edit",
      selectedState: state,
      showModal: true,
      modalTitle: "Edit State",
      errorMessage: ""
    });
  }

  deleteState(state) {
    this.setState({
      action: "delete",
      selectedState: state,
      modalDeleteTitle: "Delete State",
      showDeleteModal: true
    });
  }
  addState() {
    this.setState({
      action: "add",
      selectedState: {},
      showModal: true,
      modalTitle: "Add State",
      errorMessage: ""
    });
  }
  onHideModal() {
    this.setState({
      showModal: false
    });
  }

  showSuccessMessage(item) {
    showSuccessToastMessage(this, "toastr1", this.state.action, item, "State");
  }
  showErrorMessage(error) {
    showErrorToastMessage(this, "toastr1", error);
  }

  onHideDeleteModal() {
    this.setState({
      showDeleteModal: false
    });
  }
  validate(data) {
    if (emptyCheck(data.Name)) {
      this.setState({ errorMessage: "Name cannot be blank" });
      return false;
    }
    return true;
  }
  saveState() {
    const data = {
      CountryId: this.props.match.params.id,
      Id: this.state.action === "edit" ? this.state.selectedState.Id : 0,
      Name: this.refs["txtState"].value
    };
    if (this.validate(data)) {
      switch (this.state.action) {
        case "add":
          this.showSpinner(true);
          createState(data)
            .then(response => {
              this.showSpinner(false);
              // console.log(response);
              this.onHideModal();
              this.showSuccessMessage(data.Name);
              this.getStatesFromService();
            })
            .catch(error => {
              this.showSpinner(false);
              // console.log(error);
              this.showErrorMessage(error);
              this.onHideModal();
            });
          break;
        case "edit":
          this.showSpinner(true);
          updateState(data)
            .then(response => {
              this.showSpinner(false);
              // console.log(response);
              this.onHideModal();
              this.showSuccessMessage(data.Name);
              this.getStatesFromService();
            })
            .catch(error => {
              this.showSpinner(false);
              // console.log(error);
              this.showErrorMessage(error);
              this.onHideModal();
            });
          break;
        default:
          break;
      }
    }
  }
  confirmDeleteState() {
    this.showSpinner(true);
    deleteState(this.state.selectedState.Id)
      .then(response => {
        this.showSpinner(false);
        // console.log(response);
        this.onHideDeleteModal();
        this.showSuccessMessage(this.state.selectedState.Name);
        this.getStatesFromService();
      })
      .catch(error => {
        this.showSpinner(false);
        // console.log(error.response);
        this.showErrorMessage(error);
        this.onHideDeleteModal();
      });
  }
  handleStateChange = event => {
    let selectedState = this.state.selectedState;
    selectedState.Name = event.target.value;
    this.setState({ selectedState: selectedState });
  };

  handleSearchTermChange = event => {
    let filteredStates = this.state.masterstates.filter(d => {
      const name = String(d.Name).toLowerCase();
      return name.indexOf(event.target.value) > -1;
    });
    if (event.target.value)
      this.setState({
        states: filteredStates,
        searchTerm: event.target.value
      });
    else
      this.setState({
        states: this.state.masterstates,
        searchTerm: event.target.value
      });
  };

  render() {
    return (
      <Aux>
        <ToastContainer ref="toastr1" className="toast-top-right" />
        <Spinner showSpinner={this.state.showSpinner} />
        <h1 className="page-header">
          States
          {this.state.states.length > 0
            ? ` - ${this.state.states[0].CountryName}`
            : ""}
        </h1>
        <AdminBreadcrumb
          data={[
            { name: "Home", link: "/admin/modules/" },
            { name: "Countries", link: "/admin/countries/" },
            { name: "States" }
          ]}
        />
        <button
          className="btn btn-default add-btn"
          onClick={() => this.addState()}
        >
          Add State
        </button>
        <Search
          searchTerm={this.state.searchTerm}
          handleSearchTermChange={this.handleSearchTermChange.bind(this)}
        />
        <Grid
          headers={["#", "Name"]}
          values={this.state.states}
          indexName="Id"
          properties={["Id", "Name", "Action"]}
          edit={value => this.editState(value)}
          delete={value => this.deleteState(value)}
        />
        <AddEditModal
          showModal={this.state.showModal}
          onHideModal={() => this.onHideModal()}
          modalTitle={this.state.modalTitle}
          save={() => this.saveState()}
          form={this.addeditform}
          type="state"
          action={this.state.action}
          errorMessage={this.state.errorMessage}
        >
          <div className="form-group">
            <label>
              <RequiredField />
              Name:
            </label>
            <input
              maxLength="50"
              type="text"
              className="form-control"
              ref="txtState"
              defaultValue={this.state.selectedState.Name}
            />
          </div>
        </AddEditModal>
        <DeleteModal
          key={this.state.selectedState.Id}
          showModal={this.state.showDeleteModal}
          onHideModal={() => this.onHideDeleteModal()}
          modalTitle={this.state.modalDeleteTitle}
          confirm={() => this.confirmDeleteState()}
          name={this.state.selectedState.Name}
          type="state"
        />
      </Aux>
    );
  }
}

export default AdminStates;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminMainContent/States/States.js